export default __webpack_public_path__ + "static/media/agreement.aa9dfb6b.svg";